/**
 * Lines whose unit cost is still to be confirmed (0). A draft may carry them —
 * Bulk PO for a product never received has no price to start from — but the
 * API refuses to approve the PO until each has a cost (client issue I-1, Q3).
 */
export function costToConfirmCount(lines: { unit_cost: number | string }[]): number {
  return lines.filter((l) => !(Number(l.unit_cost) > 0)).length;
}
